class Extranet.Models.RecentAutoUpdates extends Extranet.Model

  urlRoot: () ->
    "/v2/getaways/extranet/hotels/#{@hotelUuid}/recent_auto_updates"

  initialize: (options = {})->
    @hotelUuid  = options.hotelUuid